<template>
    <div>

    </div>
</template>

<script>
    import apiUrl from "@/utils/UrlApi"

    export default {
        name: "checkToken",
        computed: {
            quary: {
                get() {
                    return this.$route.query
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
            userName: {
                get() {
                    return this.$store.getters.getUserName;
                },
                set(val) {
                    this.$store.commit("updateUserName", val);
                }
            },

        },
        methods: {
            checkWeChat(){
                // console.log('1111')
                let self = this
                localStorage.setItem('token',this.$route.query.token)
                self.getUserInfo()
                // console.log('2222')
                // self.$router.replace({
                //     name: 'systemSelection'
                // })
            },
            getUserInfo() {
                let url = apiUrl.ssoLogin
                let self = this
                this.$http.get(url, {
                    params: {
                        token:this.$route.query.token
                    }
                }).then(res => {
                    if (res.data.code === '200') {
                        localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('userName', res.data.data.userInfo.name)
                        localStorage.setItem('userId', res.data.data.userInfo.userId)

                        self.userName = res.data.data.userInfo.name
                        this.$router.push({
                            name:'VOCSystemHome'
                        })

                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },
        },
        mounted() {
            // console.log('0000')
            this.checkWeChat()
        }
    }

</script>

<style scoped>

</style>